import React from 'react';
import { SvgIcon as KendoSvgIcon } from '@progress/kendo-react-common';

/**
 * @component
 * @see {@link https://www.telerik.com/kendo-react-ui/components/common/svgicon/| KendoReact SvgIcon Component Documentation}
 * 
 * @description A wrapper around the KendoReact SvgIcon component.
 * This component allows you to render SVG icons with customizable size, className, and theme color.
 * For additional props, refer to the KendoReact SvgIcon documentation.
 * 
 * @example
 * import { gearIcon } from '@progress/kendo-svg-icons';
 * <SvgIcon icon={gearIcon} size="large" className="custom-class" themeColor="primary" />
 * 
 * @param {Object} props - Component props
 * @param {string} props.icon - The icon to display.
 * @param {string} [props.size='medium'] - The size of the icon.
 * @param {string} [props.className=''] - Additional CSS classes for the icon.
 * @param {string} [props.themeColor='info'] - The theme color for the icon.
 * @returns {JSX.Element} The rendered SvgIcon component.
 */
export const SvgIcon = ({
    icon,
    size = 'medium',
    className = '',
    themeColor = 'dark',
}) => {
  return <KendoSvgIcon 
            icon={icon} 
            size={size} 
            className={className} 
            themeColor={themeColor}
        />;
};